import _ from "lodash";
import moment from "moment-timezone";

const ANALYTICSWATCHLIST = "analyticsWatchList";

const getTime = () => {
  return moment().format("YYYY-MM-DD HH:mm:ss.SSS");
};

export const isAnalyticsRequest = (resource: string): boolean => {
  return resource === "analyticsWatchLists";
};

interface debugType {
  userId: string;
  modules: string[];
  email: string;
  createdAt: string;
  updatedAt: string;
}

export interface DebugObjectType {
  id: string;
  value: debugType[];
}

export const SettingDebugInfo: DebugObjectType = {
  id: "",
  value: [],
};

export const handleUpdateData = (
  variables: any,
  settingDate: DebugObjectType
) => {
  let createdAt = getTime();
  const res = settingDate.value.filter((e) => {
    if (e.userId === variables.userId) {
      createdAt = e.createdAt;
      return false;
    }
    return true;
  });
  const updatedAt = getTime();
  res.push({ ...variables, createdAt: createdAt, updatedAt });
  return JSON.stringify(res);
};

export const handleCreateData = (
  variables: any,
  settingDate: DebugObjectType
) => {
  if (settingDate.value.find((e) => e.userId === variables.userId)) {
    throw new Error(`${variables.userId} already exist`);
  }
  const res = _.cloneDeep(settingDate.value);
  const updatedAt = getTime();
  res.push({ ...variables, createdAt: updatedAt, updatedAt });
  return JSON.stringify(res);
};

export const handleDeleteData = (
  id: string | number,
  settingDate: DebugObjectType
) => {
  const res = settingDate.value.filter((e) => e.userId !== id);
  return JSON.stringify(res);
};

export const handleGetData = (response: any, query: string) => {
  const res = response.data.filter((item: any) => {
    return item.name === ANALYTICSWATCHLIST;
  });
  SettingDebugInfo.id = res[0].id;
  SettingDebugInfo.value = JSON.parse(res[0].value);
  const lastData = sortData(SettingDebugInfo.value, query);
  return {
    data: lastData,
    total: SettingDebugInfo.value.length,
  };
};

const sortData = (data: debugType[], query: string) => {
  const parsedQuery = parseQueryString(query);
  const result = filterAndSortData(data, parsedQuery);

  return result;
};

type SortField = "userId" | "email" | "createdAt" | "updatedAt";
interface QueryParams {
  $limit?: number;
  $skip?: number;
  $sort?: { [field in SortField]?: number };
  [key: string]: any;
}
function parseQueryString(queryString: string): QueryParams {
  const queryParams: QueryParams = {};

  const decodedQueryString = decodeURIComponent(queryString);

  const paramsArray = decodedQueryString.split("&");

  paramsArray.forEach((param) => {
    if (!param) return;

    const [key, value] = param.split("=");

    if (key.startsWith("$sort[") && key.endsWith("]")) {
      const sortField = key.substring(6, key.length - 1) as SortField;
      queryParams.$sort = { [sortField]: parseInt(value, 10) };
    } else {
      queryParams[key] = value;
    }
  });

  if (queryParams.$limit) {
    queryParams.$limit = parseInt(queryParams.$limit + "", 10);
  }

  if (queryParams.$skip) {
    queryParams.$skip = parseInt(queryParams.$skip + "", 10);
  }

  return queryParams;
}

function filterAndSortData(data: debugType[], query: QueryParams): debugType[] {
  let filteredData = [...data];

  // Filtering
  if (query["userId[$ilike]"]) {
    const ilikePattern = query["userId[$ilike]"].toLowerCase();
    filteredData = filteredData.filter((item) =>
      item.userId.toLowerCase().includes(ilikePattern)
    );
  }
  if (query["email[$ilike]"]) {
    const ilikePattern = query["email[$ilike]"].toLowerCase();
    filteredData = filteredData.filter((item) =>
      item.email.toLowerCase().includes(ilikePattern)
    );
  }

  // Sorting
  if (query.$sort) {
    const sortField = Object.keys(query.$sort)[0] as SortField;
    const sortOrder = query.$sort[sortField];

    filteredData.sort((a, b) => {
      if (sortOrder === -1) {
        return b[sortField].localeCompare(a[sortField]);
      } else {
        return a[sortField].localeCompare(b[sortField]);
      }
    });
  }

  // Limit and Skip
  if (query.$limit) {
    const s = query.$skip;
    const e = (query.$skip || 0) + query.$limit;
    filteredData = filteredData.slice(s, e);
  }

  return filteredData;
}
